import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./redux/store";
import { enableEmbeddedIO } from "./embeddedIO";
import { getIsEmbedded } from "./util/params";
import { enableLeavePageConfirmation } from "./leavePageConfirmation";

if (!("SirvHSE" in window)) {
  window.SirvHSE = {};
} // init our utility global var

if (getIsEmbedded()) {
  enableEmbeddedIO(store);
}

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

enableLeavePageConfirmation(store);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
